import React from "react";
import ContactUs from "../../components/ContactUs";
import Seo from "../../components/Seo/Seo";

const ContactUsPage = () => {
    return(
    <>
       <Seo
         title="Contact Us | JB Architects & Engineers, Tirunelveli"
         description="Get in touch with JB Architects & Engineers in Palayamkottai, Tirunelveli for architecture, interior design, and structural engineering consultations."
         keywords={[
           "architects in tirunelveli",
           "architects in palayamkottai",
           "architecture and engineering firm near me",
         ]}
         path="/contactUs"
       />
       <div className="container mt-4 mb-4">

       <ContactUs />
       </div>
    </>
    )
}
export default ContactUsPage;